import Cookies from "js-cookie";
import { createUser, getUserFromId } from "../database/helpers/user";
import { getBusinessId } from "../database/helpers/business";

export const DEMO_USER_ID = "76f84498-9dcc-4cc6-9a14-838205413312";
export const DEMO_BUSINESS_ID = "1cb923a8-a3dc-45d2-b9cb-df0af0c03c01";

export const initDemo = async ({
    setUser,
    setBusiness,
    navigate,
    location,
}) => {
    try {
        const userInfo = await getUserFromId(DEMO_USER_ID);
        const business = await getBusinessId(DEMO_BUSINESS_ID);

        if (userInfo?.length > 0 && business?.length > 0) {
            setUser(userInfo[0]);
            setBusiness(business[0]);

            localStorage.setItem("business_id", DEMO_BUSINESS_ID);
            Cookies.set("tempUserId", DEMO_USER_ID, { expires: 1 });

            const lastVisited = localStorage.getItem("lastVisited");
            navigate(lastVisited || "/Accounts", { replace: true });
            return;
        }

        const newUser = await createUser({
            id: DEMO_USER_ID,
            telco_network: "",
            phone_number: "",
            is_active: true,
            business: DEMO_BUSINESS_ID,
        });

        const response = await newUser.createBusiness(
            "Business Name",
            DEMO_BUSINESS_ID,
            false,
            "Business Category"
        );

        setUser(newUser);
        setBusiness(response);

        localStorage.setItem("business_id", response.id);
        sessionStorage.setItem("demo", "true");
        Cookies.set("tempUserId", newUser.id, { expires: 1 });

        const currentPath = location.pathname;
        if (currentPath === "/") {
            navigate("/Accounts", { replace: true });
        } else {
            navigate(currentPath);
        }
    } catch (err) {
        console.error("Demo error:", err);
    }
};
